/*** IMPORTS FROM imports-loader ***/
var define = false;

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
export { _classCallCheck as default };
